<template>
  <div>
    <el-form
      label-position="top"
      :model="filterOptions"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="Vevő"
            prop="customer"
          >
            <el-input
              v-model="filterOptions.customer"
              @keyup.native="filter"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="Számla"
            prop="invoiceNumber"
          >
            <el-input
              v-model="filterOptions.invoiceNumber"
              @keyup.native="filter"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button
            @click="download"
            style="text-align: right; margin-top: 21px;"
          >Excel letöltés</el-button>
        </el-col>
        <el-col :span="3">
          <div><strong>Bruttó</strong></div>
          <div
            v-for="[currencyCode, value] of Object.entries(grossSum)"
            :key="currencyCode"
          >
            {{ value | currency(currencyCode) }}
          </div>
        </el-col>
        <el-col :span="3">
          <div><strong>Kiegyenlített összeg</strong></div>
          <div
            v-for="[currencyCode, value] of Object.entries(paidSum)"
            :key="currencyCode"
          >
            {{ value | currency(currencyCode) }}
          </div>
        </el-col>
        <el-col :span="3">
          <div><strong>Kintlévőség</strong></div>
          <div
            v-for="[currencyCode, value] of Object.entries(outstandingSum)"
            :key="currencyCode"
          >
            {{ value | currency(currencyCode) }}
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item
            label="Ki nem egyenlített számlák"
            prop="payment_date"
          >
            <el-select
              v-model="filterOptions.expirationType"
              @change="filter"
            >
              <el-option
                value="all"
                label="Összes"
              >
                Összes
              </el-option>
              <el-option
                value="expired"
                label="Lejárt"
              >
                Lejárt
              </el-option>
              <el-option
                value="nonExpired"
                label="Nem lejárt"
              >
                Nem lejárt
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Pénznem"
            prop="payment_date"
          >
            <el-select
              v-model="filterOptions.currency"
              @change="filter"
              clearable
            >
              <el-option
                value="HUF"
                label="Forint"
              >
                Forint
              </el-option>
              <el-option
                value="EUR"
                label="Euro"
              >
                Euro
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="Számla kelt"
            prop="payment_date"
          >
            <el-date-picker
              v-model="filterOptions.issueDateRange"
              class="filter-date"
              style="margin-right: 10px;"
              type="daterange"
              clearable
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="dateRangeOptions"
              @change="filter"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="Számla teljesítés"
            prop="payment_date"
          >
            <el-date-picker
              v-model="filterOptions.deliveryDateRange"
              class="filter-date"
              style="margin-right: 10px;"
              type="daterange"
              clearable
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="dateRangeOptions"
              @change="filter"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="Számla határidő"
            prop="payment_date"
          >
            <el-date-picker
              v-model="filterOptions.deadlineDateRange"
              class="filter-date"
              style="margin-right: 10px;"
              type="daterange"
              clearable
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="dateRangeOptions"
              @change="filter"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="Korosítás - Viszonyítási dátum "
            prop="agingComparisonDate"
          >
            <el-date-picker
              v-model="filterOptions.agingComparisionDate"
              class="filter-date"
              style="margin-right: 10px;"
              type="date"
              clearable
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              @change="filterRemote"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      size="mini"
      :data="invoices"
      v-loading="loading"
      border
    >
      <el-table-column
        label="Vevő"
        sortable
        prop="customer_name"
      />
      <el-table-column
        label="Státusz"
        width="170"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.outstanding != 0 && scope.row.outstanding == scope.row.gross_price">
            Tartozik
          </div>
          <div v-if="scope.row.outstanding == 0">
            Kiegyenlítve
          </div>
          <div v-if="scope.row.outstanding != 0 && scope.row.outstanding != scope.row.gross_price">
            Részben teljesítve
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Számla"
        sortable
        :sort-method="sortByInvoiceNumber"
        width="170"
        prop="invoice_number"
      >
        <template slot-scope="scope">
          <receipt-link
            :id="scope.row.id"
            :label="scope.row.invoice_number"
            type="invoice"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Kelt"
        sortable
        width="110"
        prop="issue_date"
      >
        <template slot-scope="scope">
          {{ scope.row.issue_date | date }}
        </template>
      </el-table-column>
      <el-table-column
        label="Teljesítés"
        sortable
        width="110"
        prop="delivery_date"
      >
        <template slot-scope="scope">
          {{ scope.row.delivery_date | date }}
        </template>
      </el-table-column>
      <el-table-column
        label="Határidő"
        sortable
        width="110"
        prop="payment_date"
      >
        <template slot-scope="scope">
          <div
            v-if="scope.row.is_expired"
            style="color: red"
          >
            {{ scope.row.payment_date | date }}
          </div>
          <div
            v-else
          >
            {{ scope.row.payment_date | date }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Számla teljes összege"
        prop="gross_price"
        sortable
        width="180"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.gross_price | currency(scope.row.currency_code) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Kiegyenlített összeg"
        prop="paid"
        sortable
        width="180"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.paid | currency(scope.row.currency_code) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Kintlévőség (a számla egyenlege)"
        prop="outstanding"
        sortable
        width="240"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.outstanding | currency(scope.row.currency_code) }}
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template slot-scope="scope">
          <div v-if="0.00 != parseFloat(scope.row.outstanding)">
            <el-button size="mini" @click="() => showDialog(scope.row)">
              Kiegyenlítés
            </el-button>
          </div>
          <div v-else>
            Kiegyenlítve
          </div>
        </template>
      </el-table-column>
    </el-table>
    <payment-dialog
      v-if="isShown"
      :invoice-id="selectedInvoice.id"
      :on-close="handleOnClose"
    />
  </div>
</template>

<script>
  import moment from 'moment';
  import ReceiptLink from '../../../utils/ReceiptLink';
  import PaymentDialog from '../PaymentDialog';
  import Payee from './Payee';

  export default {
    components: {
      ReceiptLink,
      PaymentDialog,
    },
    data() {
      return {
        loading: false,
        isShown: false,
        defaultInvoices: [],
        selectedInvoice: {},
        invoices: [],
        grossSum: {},
        paidSum: {},
        outstandingSum: {},
        sum: 0,
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment().weekday(1).toDate();
              const end = moment().weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment().subtract({ weeks: 1 }).weekday(1).toDate();
              const end = moment().subtract({ weeks: 1 }).weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment().subtract({ months: 1 }).startOf('month').toDate();
              const end = moment().subtract({ months: 1 }).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment().subtract({ months: 3 }).startOf('month').toDate();
              const end = moment().subtract({ months: 1 }).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment().subtract({ years: 1 }).startOf('year').toDate();
              const end = moment().subtract({ years: 1 }).endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        filterOptions: {
          issueDateRange: null,
          deliveryDateRange: null,
          deadlineDateRange: null,
          expirationType: 'expired',
          customer: '',
          invoiceNumber: '',
          currency: null,
          agingComparisionDate: null
        }
      };
    },
    methods: {
      sortByInvoiceNumber(a, b) {
        const aParts = a.invoice_number.split('/')
        const aPrefix = aParts.length === 3 ? aParts[0] : aParts[0].split('-')[0]
        const aYear = aParts.length === 3 ? aParts[1] : aParts[0].split('-')[1]
        const aNumber = aParts.length === 3 ? aParts[2] : aParts[1]

        const bParts = b.invoice_number.split('/')
        const bPrefix = bParts.length === 3 ? bParts[0] : bParts[0].split('-')[0]
        const bYear = bParts.length === 3 ? bParts[1] : bParts[0].split('-')[1]
        const bNumber = bParts.length === 3 ? bParts[2] : bParts[1]

        const aWeight = (aPrefix.match(/\d+/g) ? aPrefix.match(/\d+/g)[0] : 1) * 1000 + aYear * 10 + aNumber
        const bWeight = (bPrefix.match(/\d+/g) ? bPrefix.match(/\d+/g)[0] : 1) * 1000 + bYear * 10 + bNumber
        return aWeight < bWeight ? 1 : -1
      },
      showDialog(invoice) {
        this.selectedInvoice = invoice
        this.isShown = true
      },
      updateOutstanding(invoiceId, amount) {
        this.invoices = this.invoices.map(invoice => {
          if (invoice.id === invoiceId) {
            return {
              ...invoice,
              outstanding: invoice.outstanding - amount
            };
          } else {
            return invoice;
          }
        });
        this.defaultInvoices = this.defaultInvoices.map(invoice => {
          if (invoice.id === invoiceId) {
            return {
              ...invoice,
              outstanding: invoice.outstanding - amount
            };
          } else {
            return invoice;
          }
        });
      },
      async load() {
        this.loading = true;
        try {
          let url = 'api/balances/top';
          
          if(this.filterOptions.agingComparisionDate){
            url += `?aging_comparison_date=${this.filterOptions.agingComparisionDate}`;
          }
          this.defaultInvoices = await axios.get(url);

          this.filter()
        } catch (e) {
        }
        this.loading = false;
      },
      handleOnClose() {
        this.isShown = false
        this.load()
      },
      async download() {
        const invoiceIds = this.invoices.map(invoice => invoice.id)
        try {
          const excel = await axios({
            url: `api/balances/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              invoice_ids: invoiceIds,
              aging_comparison_date: this.filterOptions.agingComparisionDate
            },
          });
          saveAs(excel, `balance.xlsx`);
        } catch (e) {}
      },
      async filterRemote() {
        this.loading = true;
        try {
          let url = 'api/balances/top';
          if(this.filterOptions.agingComparisionDate){
            url += `?aging_comparison_date=${this.filterOptions.agingComparisionDate}`;
          }

          this.defaultInvoices = await axios.get(url);
          this.filter()
        } catch (e) {

        }
        this.loading = false;
      },
      filter() {
        let results = this.defaultInvoices;
        if (this.filterOptions.customer) {
          results = results.filter(invoice => invoice.customer_name.toLowerCase().indexOf(this.filterOptions.customer.toLowerCase()) !== -1);
        }
        if (this.filterOptions.invoiceNumber) {
          results = results.filter(invoice => (invoice.invoice_number !== null && invoice.invoice_number.toLowerCase().indexOf(this.filterOptions.invoiceNumber.toLowerCase()) !== -1));
        }
        if (this.filterOptions.expirationType === 'expired') {
          results = results.filter(invoice => invoice.is_expired);
        }
        if (this.filterOptions.expirationType === 'nonExpired') {
          results = results.filter(invoice => !invoice.is_expired);
        }
        if (this.filterOptions.currency) {
          results = results.filter(invoice => invoice.currency_code === this.filterOptions.currency);
        }
        if (this.filterOptions.issueDateRange) {
          const from = moment(this.filterOptions.issueDateRange[0]);
          const to = moment(this.filterOptions.issueDateRange[1]);
          results = results.filter(invoice => moment(invoice.issue_date).isBetween(from, to, undefined, []));
        }
        if (this.filterOptions.deliveryDateRange) {
          const from = moment(this.filterOptions.deliveryDateRange[0]);
          const to = moment(this.filterOptions.deliveryDateRange[1]);
          results = results.filter(invoice => moment(invoice.delivery_date).isBetween(from, to, undefined, []));
        }
        if (this.filterOptions.deadlineDateRange) {
          const from = moment(this.filterOptions.deadlineDateRange[0]);
          const to = moment(this.filterOptions.deadlineDateRange[1]);
          results = results.filter(invoice => moment(invoice.payment_date).isBetween(from, to, undefined, []));
        }
        this.invoices = results;

        this.grossSum = {}
        this.paidSum = {}
        this.outstandingSum = {}

        this.invoices.forEach(invoice => {
          if (!this.grossSum[invoice.currency_code]) {
            this.grossSum[invoice.currency_code] = 0
          }
          this.grossSum[invoice.currency_code] += invoice.gross_price
          if (!this.paidSum[invoice.currency_code]) {
            this.paidSum[invoice.currency_code] = 0
          }
          this.paidSum[invoice.currency_code] += invoice.paid
          if (!this.outstandingSum[invoice.currency_code]) {
            this.outstandingSum[invoice.currency_code] = 0
          }
          this.outstandingSum[invoice.currency_code] += invoice.outstanding
        })
      },
    },
    async mounted() {
      await this.load();
    }
  };
</script>
